import { getApiBaseUrl } from "../utils/getApiBaseUrl";

const API_BASE_URL = getApiBaseUrl();

async function parseJson(res) {
  const text = await res.text();
  let body = {};
  try {
    body = text ? JSON.parse(text) : {};
  } catch {
    body = {};
  }
  return { res, body };
}

function unwrapData(body) {
  if (body?.data && typeof body.data === "object") return body.data;
  return body;
}

export function isStripeCryptoOnrampEnabledOnClient() {
  const raw = String(process.env.REACT_APP_STRIPE_CRYPTO_ONRAMP_ENABLED || "").trim().toLowerCase();
  return raw === "true" || raw === "1";
}

/**
 * POST /api/crypto-onramp/create-session
 * @param {{ walletAddress: string, sourceAmount?: string, returnUrl?: string }} params
 */
export async function createCryptoOnrampSession({
  walletAddress,
  sourceAmount,
  destinationCurrency,
  destinationNetwork,
  returnUrl,
} = {}) {
  const { res, body } = await parseJson(
    await fetch(`${API_BASE_URL.replace(/\/$/, "")}/api/crypto-onramp/create-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        walletAddress,
        sourceAmount,
        destinationCurrency,
        destinationNetwork,
        returnUrl,
      }),
    })
  );

  if (!res.ok) {
    const err = new Error(body?.message || "Could not start ETH funding.");
    err.status = res.status;
    err.code = body?.code;
    throw err;
  }

  return unwrapData(body);
}
